import React, { useContext, useState, useMemo, useEffect, useRef } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { dbPost } from '../../apis/commonApi';
import MemberController from '../../controllers/member/MemberController';
import { useNavigate } from 'react-router-dom';

const UserWithdrawal = () => {
  useEffect(() => {
    document.title = '기업 사용자 탈퇴';
  }, []);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const gridRef = useRef(null);
  const [valueObj, setValueObj] = useState(null);
  const validateService = new ValidateService(modalService);

  const navigate = useNavigate();

  const controller = useMemo(() => {
    return new MemberController(
      { store, updateStore },
      modalService,
      validateService,
      navigate,
      [gridRef],
      {
        valueObj,
        setValueObj,
      }
    );
  }, [store, modalService, validateService]);

  const [isDisabled, setIsDisabled] = useState(true);
  const [formData, setFormData] = useState({
    entId: '',
    entSn: '',
    entPswd: '',
  });

  const withdrawal = () => {
    const url = '/member/withdrawalEnt.do';
    const param = {
      entId: formData.entId.replace(/\s+/g, ''),
      entSn: formData.entSn,
      entPswd: formData.entPswd,
    };
    dbPost(url, param)
      .then(response => {
        if (response instanceof Error) {
          modalService.errorAlert(
            '데이터 처리중 에러가 발생하였습니다',
            () => {}
          );
        } else {
          if (response === true) {
            modalService.successAlert('탈퇴가 완료되었습니다.', () => {
              afterWithdrawal();
            });
          } else {
            modalService.errorAlert('비밀번호를 확인해주세요.', () => {});
          }
        }
      })
      .catch(error => {});
  };

  const afterWithdrawal = async () => {
    try {
      await fnLogout();
    } catch (error) {
      throw error;
    }
  };

  const fnLogout = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (token) {
        await doLogout(token); // 로그아웃 API 호출
      }
    } catch (e) {}

    sessionStorage.removeItem('token');

    updateStore('authrtId', 'NU');
    updateStore('menuList', []);
    updateStore('logined', false);
    updateStore('userType', '');
    updateStore('entSn', '');
    updateStore('userSn', '');
    updateStore('userId', '');
    updateStore('userNm', '');
    updateStore('selectedFirstDepthMenu', '');

    let menuList = [];

    try {
      menuList = await getAuthrtMenu('NU');
      updateStore('menuList', menuList);
      setHeaderMenu(menuList.filter(menu => menu.level === 0));
    } catch (error) {}

    sessionStorage.removeItem('remainingTime');
    sessionStorage.clear();

    navigate('/');
  };

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entId: store.userId || '',
        entSn: store.entSn || '',
      }));
    }
  }, [store]);

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleCheckboxChange = e => {
    setIsDisabled(!e.target.checked);
  };

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 아이디 비밀번호 입력 input 붙여넣기 금지
  const handlePaste = e => {
    e.preventDefault();
  };

  useEffect(() => {}, [formData.userId]);

  const navigateTo = url => {
    navigate(url);
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 탈퇴</h2>
      </div>
      {/* //페이지 타이틀 영역 */}

      <div className="txt-box notice">
        <ul>
          <li>
            &bull; 탈퇴한 아이디로는 다시 가입할 수 없으며, 아이디 및 데이터는
            복구할 수 없으므로 사용자탈퇴는 신중하게 진행해주시기 바랍니다.
          </li>
          <li>
            &bull; 사용자탈퇴 시 실수를 방지하기 위해 비밀번호를 한번 더
            확인합니다.
          </li>
        </ul>
      </div>
      <p className="tbl-msg gap-lg">
        <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
      </p>
      <div className="hr"></div>
      <fieldset className="gap-sm">
        <legend>비밀번호 변경</legend>
        <div className="fieldset">
          <div className="form-group">
            <div className="form-title">
              <label htmlFor="entPswd">
                비밀번호 확인<em className="star-require">*</em>
              </label>
            </div>
            <div className="form-conts">
              <div className="input-group">
                <input
                  type="password"
                  id="entPswd"
                  value={formData.entPswd || ''}
                  className="form-control"
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown} // 비밀번호 스페이스바 금지
                  onPaste={handlePaste} // 비밀번호 붙여넣기 금지
                  maxLength={20}
                  autoComplete="new-password"
                  aria-labelledby="entPswd"
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div className="txt-box gap-lg">
        <ul>
          <li>&bull; 탈퇴할 경우 재사용 및 복구가 불가능 합니다.</li>
          <li>
            &bull; 탈퇴 후 게시판 등의 서비스에 등록한 게시물은 삭제되지 않고
            유지됩니다.
          </li>
        </ul>
      </div>
      <div className="page-btn-wrap both">
        <div className="form-check">
          <input
            type="checkbox"
            id="chk_1-1a"
            onChange={handleCheckboxChange}
            aria-labelledby="chk_1-1a"
          />
          <label htmlFor="chk_1-1a">
            안내사항을 모두 확인하였으며 사용자탈퇴 시 복구가 불가능함에
            동의합니다.
          </label>
        </div>
        <div>
          <button
            type="button"
            className="btn xlg tertiary"
            onClick={() => {
              navigateTo('/member/userInfo/userInfo');
            }}
          >
            취소
          </button>
          <button
            type="submit"
            className="btn xlg primary"
            disabled={isDisabled}
            onClick={() => {
              withdrawal();
            }}
          >
            사용자 탈퇴
          </button>
        </div>
      </div>
    </>
  );
};

export default UserWithdrawal;
